import React from "react";
import {
  Alert,
  AlertTitle,
  Snackbar,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

// Static Alert Component
export const AutobiaAlert = ({
  severity = "info",
  title,
  children,
  onClose,
  variant = "standard",
  icon,
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Alert
      severity={severity}
      variant={variant}
      icon={icon}
      onClose={onClose}
      sx={{
        borderRadius: "12px",
        "& .MuiAlert-icon": {
          color: `${severity}.main`,
        },
        ...sx,
      }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </Alert>
  );
};

// Toast/Snackbar Alert Component
export const AutobiaToast = ({
  open,
  onClose,
  message,
  severity = "info",
  autoHideDuration = 6000,
  position = { vertical: "top", horizontal: "center" },
  action,
}) => {
  const theme = useTheme();

  const defaultAction = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={position}
      sx={{
        "& .MuiSnackbarContent-root": {
          borderRadius: "12px",
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        action={action || defaultAction}
        sx={{
          width: "100%",
          borderRadius: "12px",
          "& .MuiAlert-icon": {
            color: "white",
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AutobiaAlert;